import React, {useState} from 'react';
import {
  StockCard,
  CardBoldText,
  CardContainer,
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import { Text, Pressable } from 'react-native';
import { useMutation } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { elRed } from 'app/src/styles/colors';
import { DocumentsContainer, NameColumn, XColumn } from '../components/Attachments/elements';

const StockNumberCard = props => {
  const { stockNumber, updateStockNumbers } = props;

  const onRemove = () => {
    updateStockNumbers(stockNumber, 'remove');
  }

  return (
    <CardContainer>
      <StockCard>
        <DocumentsContainer>
          <NameColumn><Text>{stockNumber}</Text></NameColumn>
          <XColumn>
            <Pressable
              style={{
                marginBottom: '0px',
                marginRight: '2px',
                zIndex: 9999999,
                alignSelf: 'flex-end',
              }}
              onPress={() => {
                onRemove();
              }}
            >
              <FontAwesomeIcon
                icon={faSquareXmark}
                size='xl'
                style={{color: elRed}}
              />
            </Pressable>
          </XColumn>
        </DocumentsContainer>
      </StockCard>
    </CardContainer>
  )
}

export default StockNumberCard;